/**
 * 防抖函数
 * @param fn 需要防抖的函数
 * @param delay 防抖延迟时间
 * @param immediate 是否立即执行
 * @returns 返回一个防抖后的函数
 */
export const debounce = (fn: Function, delay: number, immediate: boolean = false) => {
  let timer: number | null = null;
  return function(this: any, ...args: any[]) {
    if (timer) clearTimeout(timer);
    if (immediate) {
      const callNow = !timer;
      timer = setTimeout(() => {
        timer = null;
      }, delay);
      if (callNow) fn.apply(this, args);
    } else {
      timer = setTimeout(() => {
        fn.apply(this, args);
      }, delay);
    }
  };
};

/**
 * 节流函数
 * @param fn 需要节流的函数
 * @param delay 节流时间间隔
 * @returns 返回一个节流后的函数
 */
export const throttle = (fn: Function, delay: number) => {
  let lastTime = 0;
  return function(this: any, ...args: any[]) {
    const now = Date.now();
    if (now - lastTime >= delay) {
      fn.apply(this, args);
      lastTime = now;
    }
  };
};
